var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { alpha, Box, CircularProgress } from "@mui/material";
import { combineSxProps } from "../../Utils";
export const Dropzone = forwardRef((props, ref) => {
    const { hint, loading, active, error, disabled, sx, children } = props, boxProps = __rest(props, ["hint", "loading", "active", "error", "disabled", "sx", "children"]);
    const showHint = hint && !disabled;
    return (_jsxs(Box, Object.assign({ sx: combineSxProps(sx, containerSxProps(loading, showHint, active, error, disabled)), ref: ref }, boxProps, { children: [_jsx(Box, { sx: overlaySxProps(loading, showHint, active, error) }), children, loading
                ? _jsx(CircularProgress, { sx: { position: "absolute" }, size: "32px" }) // TODO: This should be the gradient progress, but it isn't in the component library yet so we'll need to replace it when we will add it.
                : _jsx(_Fragment, {})] })));
});
const getBorderColor = (theme, loading, showHint, active, error, disabled) => {
    if (loading) {
        return theme.palette.grey[300];
    }
    if (error) {
        return theme.palette.error.main;
    }
    if (disabled) {
        return "transparent";
    }
    if (active) {
        return theme.palette.primary.main;
    }
    if (showHint) {
        return theme.palette.primary.light;
    }
    return theme.palette.grey[300];
};
const getOverlayBackgroundColor = (theme, loading, showHint, active, error) => {
    if (loading) {
        return alpha(theme.palette.common.white, 0.3);
    }
    if (error) {
        return alpha(theme.palette.error.main, 0.3);
    }
    if (active) {
        return alpha(theme.palette.primary.main, 0.3);
    }
    if (showHint) {
        return alpha(theme.palette.primary.main, 0.12);
    }
    return undefined;
};
const containerSxProps = (loading, showHint, active, error, disabled) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: theme => `1px dashed ${getBorderColor(theme, loading, showHint, active, error, disabled)}`
});
const overlaySxProps = (loading, showHint, isDragActive, isDragReject) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: theme => getOverlayBackgroundColor(theme, loading, showHint, isDragActive, isDragReject)
});
//# sourceMappingURL=Dropzone.js.map